export const customStylesClient = {
	container: (provided) => ({
		...provided,
		width: 100, // Set the width here
	}),
	// You can also set the width of the control (input area) if needed
	control: (provided, state) => ({
		...provided,
		// backgroundColor: state.isFocused ? 'white' : 'transparent', // Transparent when idle, white when focused
		// borderColor: state.isFocused ? '#ccc' : 'transparent', // Optional: transparent border when idle
		// boxShadow: state.isFocused ? '0 0 0 1px #ccc' : 'none', // Optional: remove shadow when idle
		// color: '#000', // Text color in the input
		width: 100,
		cursor: "pointer",
	}),
	option: (provided, state) => ({
		...provided,
		cursor: "pointer",
	}),
	placeholder: (provided) => ({
		...provided,
		// color: '#000', // Text color of the placeholder
		// opacity: 0.5, // Adjust opacity if needed
	}),
	singleValue: (provided, state) => ({
		...provided,
		// color: state.isFocused ? '#000' : '#000', // Text color when an option is selected
	}),
};

export const customStylesLocation = {
  container: (provided) => ({
    ...provided,
    // width: 220, // Set the width here
  }),
  // You can also set the width of the control (input area) if needed
  control: (provided, state) => ({
    ...provided,
    // backgroundColor: state.isFocused ? 'white' : 'transparent', // Transparent when idle, white when focused
    // borderColor: state.isFocused ? '#ccc' : 'transparent', // Optional: transparent border when idle
    // boxShadow: state.isFocused ? '0 0 0 1px #ccc' : 'none', // Optional: remove shadow when idle
    // color: '#000', // Text color in the input
    width: 210,
    cursor: "pointer",
  }),
  option: (provided, state) => ({
    ...provided,
    cursor: "pointer",
    paddingLeft: "30px", // Add indentation here
  }),
  placeholder: (provided) => ({
    ...provided,
    // color: '#000', // Text color of the placeholder
    // opacity: 0.5, // Adjust opacity if needed
  }),
  singleValue: (provided, state) => ({
    ...provided,
    // color: state.isFocused ? '#000' : '#000', // Text color when an option is selected
  }),
};